<template >
    <!-- start of the header with slot -->
    <nav class="diy_header header-navbar navbar navbar-expand-lg align-items-center floating-nav navbar-light navbar-shadow bg-primary;z-index:200">
        <div class="navbar-container d-flex content">
            <ul class="nav navbar-nav bookmark-icons align-items-center d-xl-none">
                <li class="nav-item">
                    <a class="nav-link menu-toggle" href="javascript:void(0);">
                        <vue-feather class="ficon" type="menu"></vue-feather>
                    </a>
                </li>
            </ul>
            <ul class="nav navbar-nav bookmark-icons align-items-center d-none d-xl-flex">
                <!-- <li class="nav-item mr-auto"><a class="navbar-brand d-sm-flex d-none" href="#">
                    <span class="">
                        <img src="https://test-creditfixrr-spaces.nyc3.digitaloceanspaces.com/Marketing/creditfixrr-best-credit-repair-software-logo.png" alt="creditfixrr logo" width="150">
                    </span></a>
                </li> -->
                <!-- links to right section of the header -->

                <slot name="left_section"></slot>
                <!-- links to right section of the header -->
            </ul>
            <ul class="nav navbar-nav align-items-center ml-auto">
                <li class="nav-item" id="append_tour_control" ref="append_tour_control">
                    <a class="nav-link font-weight-bold d-none d-md-block" href="#" aria-haspopup="true" aria-expanded="false" v-if="settingStore.tour_setup.viewTour == 'start'" @click="startTour(false)" >
                        <vue-feather  type="map" size="12"></vue-feather>
                        Start Tour
                    </a>
                    <a class="nav-link font-weight-bold d-none d-md-block" href="#" aria-haspopup="true" aria-expanded="false" @click="startTour(true)"  v-else-if="settingStore.tour_setup.viewTour == 'resume'">
                        <vue-feather  type="play" size="12"></vue-feather>
                        Resume Tour
                    </a>
                    <a  v-else></a>
                </li>

                <checkout-dropdown v-if="userStore.user.isDIY"></checkout-dropdown>
                <notification-dropdown :user="user.userId" ></notification-dropdown>
                <!-- let side of the header -->
                <!-- <slot name="right_section"></slot> -->
                <li class="nav-item dropdown dropdown-user" :class="{ 'show': isProfileMenuActive }" id="profile_step">
                    <a
                        class="nav-link dropdown-user-link"
                        id="dropdown-user"
                    >
                        <div class="user-nav d-sm-flex d-none">
                            <span class="user-name fw-bolder">
                                {{ user.fullName }}
                                <span v-if="userStore.user.isDIY">
                                    (<span class="user-status" v-if="user.hasFamily">
                                        Family
                                    </span>
                                    <span class="user-status" v-else>
                                        Self
                                    </span>)
                                </span>
                                <span v-else-if="userStore.user.isBusiness">
                                    (<span class="user-status">
                                        Business
                                        <!-- <span v-if="user.onTrial">
                                            {{ localizationStore.translate('trial.user') }}
                                        </span> -->
                                    </span>)
                                </span>
                            </span>
                            <span v-if="userStore.user.balance" class="user-status d-flex align-items-center">
                                <div
                                    v-if="userStore.user.permissions && userStore.user.permissions.canTopUp"
                                    @click="openModal('#top-up-modal')"
                                    class="mr-50 badge badge-pill badge-glow badge-success"
                                >
                                    Top Up
                                </div>
                                Credit Balance: ${{ fix(userStore.user.balance, settingStore.payment.precision) }}
                            </span>
                        </div>
                        <span @click="isProfileMenuActive = !isProfileMenuActive" class="avatar">
                            <img
                                class="round"
                                :src="settingStore.logo"
                                alt="avatar"
                                height="40"
                                width="40"
                            >
                            <span class="avatar-status-online"></span>
                        </span>
                    </a>
                    <div
                        class="dropdown-menu dropdown-menu-right"
                        :class="{ 'show': isProfileMenuActive }"
                        aria-labelledby="dropdown-user"
                    >
                        <router-link
                            :to="{ name: 'user-account'}"
                            class="dropdown-item" target="_self"
                            v-if="!userStore.user.isTeamMember"
                        >
                            <vue-feather class="mr-50" type="user"></vue-feather>
                            {{ localizationStore.translate('Profile') }}
                            <span class="d-lg-none d-md-none" v-if="user.onTrial">
                                {{ localizationStore.translate('trial.user') }}
                            </span>
                        </router-link>

                        <div class="dropdown-divider"></div>

                        <router-link
                            :to="{ name: 'billing-subscriptions-plan'}"
                            class="dropdown-item" target="_self"
                            v-if="!userStore.user.isTeamMember"
                        >
                            <vue-feather type="credit-card" class="mr-50"></vue-feather>
                            <span>{{ localizationStore.translate('billing') }}</span>
                        </router-link>

                        <router-link
                            :to="{ name: 'billing-plans'}"
                            class="dropdown-item" target="_self"
                            v-if="!userStore.user.isTeamMember"
                        >
                            <vue-feather class="mr-50" type="dollar-sign"></vue-feather>
                            {{ localizationStore.translate('plans') }}
                        </router-link>
                        <router-link
                            :to="{ name: 'products'}"
                            class="dropdown-item"
                            target="_self"
                            v-if="!userStore.user.isTeamMember"
                        >
                            <vue-feather type="book" class="mr-50" />
                            <span>{{ localizationStore.translate('ebook') }}</span>
                        </router-link>
                        <router-link
                            :to="{ name: 'settings'}"
                            class="dropdown-item" target="_self"
                            v-if="userStore.user.isDIY"
                        >
                            <vue-feather class="mr-50" type="settings"></vue-feather>
                            {{ localizationStore.translate('settings') }}
                        </router-link>

                        <router-link
                            :to="{ name: 'blogs'}"
                            class="dropdown-item" target="_self"
                        >
                            <vue-feather class="mr-50" type="circle"></vue-feather>
                            <span>{{ localizationStore.translate('Blog') }}</span>
                        </router-link>

                        <a class="dropdown-item" href="https://creditfixrr.crunch.help/en">
                            <vue-feather class="mr-50" type="help-circle"></vue-feather>
                            {{ localizationStore.translate('faq') }}
                        </a>
                        <a class="dropdown-item" @click="logout" href="#">
                            <vue-feather class="mr-50" type="log-out" />
                            {{ localizationStore.translate('logout') }}
                        </a>
                    </div>

                </li>
                <!--slots -->
            </ul>
        </div>
    </nav>
    <!-- End of the header -->
</template>
<script>
import { ref } from 'vue'
import CheckoutDropdown from '../../../CheckoutDropdown.vue'
import NotificationDropdown from '../../../NotificationDropdown.vue'
import { useUserStore } from '../../../../stores/UserStore.js'
import { useLocalizationStore } from '../../../../stores/LocalizationStore.js'
import { useSettingStore } from '../../../../stores/SettingStore.js'
import { useRoute } from 'vue-router'
import { fix } from 'mathjs'
import { closeModal, hideModal, openModal } from '../../../../utilities/_helpers'
import { startTour,resumeTour } from '../../../dashboard/Tours/dashboard_tour.js'
export default{
    components:{
        CheckoutDropdown,
        NotificationDropdown
    },
    props:{
        user:{
            type:[Array,Object]
        },
    },
    setup() {
        return {
            localizationStore: useLocalizationStore(),
            openModal: openModal,
            userStore:useUserStore(),
            settingStore: useSettingStore(),
            fix: fix,
            isProfileMenuActive: ref(false),
            appendTourControl:ref(null),
            startTour:startTour,
            resumeTour:resumeTour
        }
    },
    created() {
    },
    computed:{

    },
    mounted(){
        this.settingStore.setTourComponent(this.$refs.append_tour_control)
    },
    methods:{
        logout() {
            const route = this.$router.resolve({ name: 'logout-link'}).href;
            axios.get(route)
            .then(function (response) {
                localStorage.clear();
                location.reload();
            });
        }
    }
}
</script>
<style>
.diy_header.header-navbar.floating-nav {
    position: fixed;
    right: 0px;
    margin: 0px !important;
    width: 100%;
    border-radius: 0px !important;
    z-index: 14;
    background:#4b9a5e !important;
    color:white;
}
.diy_header.floating-nav {
    width: 100% !important;
}
</style>
